import { WbSunny } from '@e3dc-react/icons'
import { isSameHour } from '@e3dc-react/shell/Libs/date'
import { useTheme } from '@mui/material'
import React from 'react'
import { Area, AreaChart, ResponsiveContainer } from 'recharts'
import ChartBlankView from 'src/Libs/chart-kit/shared/components/ChartBlankView'
import type { PvForecastWidgetChartDataItem } from '../../types'

type DotProps = {
  cx: number
  cy: number
  payload: {
    time: number
  }
  key: string | undefined
}

type Props = {
  pvForecastWidgetChartData: PvForecastWidgetChartDataItem[]
  isNoDataAvailable: boolean
}

/*
 * Chart for pv forecast widget
 */
const PvForecastWidgetChart: React.FC<Props> = ({ pvForecastWidgetChartData, isNoDataAvailable }) => {
  const theme = useTheme()

  if (isNoDataAvailable) return <ChartBlankView />

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={60}>
      <AreaChart data={pvForecastWidgetChartData}>
        {/* If showRemainingProduction is true, this line is responsible for displaying the grey part of the line chart */}
        <Area
          type="monotone"
          dataKey="pastPower"
          stroke={theme.palette.grey.grey06}
          fill="transparent"
          strokeWidth={1.33}
          dot={false}
          isAnimationActive={false}
        />
        <Area
          type="monotone"
          dataKey="futurePower"
          stroke={theme.palette.pvForecastWidgetChart.pvForecastStrokeLineColor}
          fill={theme.palette.pvForecastWidgetChart.pvForecastActiveColor}
          strokeWidth={1.33}
          dot={({ key, ...rest }: DotProps) => <CustomDot key={key} {...rest} />}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default PvForecastWidgetChart

const CustomDot = (props: Pick<DotProps, 'cx' | 'cy' | 'payload'>): React.ReactNode => {
  const { cx, cy, payload } = props

  const isCurrentTime = isSameHour(new Date(), new Date(payload.time))

  if (isCurrentTime) return <WbSunny x={cx - 8} y={cy - 8} />
  return null
}
